'use client';
import Image from 'next/image';

const SeniorsIsTheWayImagesPath = '/images/SeniorsIsTheWay';
const card1ImagePath = `${SeniorsIsTheWayImagesPath}/SeniorsIsTheWay1.webp`;
const card2ImagePath = `${SeniorsIsTheWayImagesPath}/SeniorsIsTheWay2.webp`;
const card3ImagePath = `${SeniorsIsTheWayImagesPath}/SeniorsIsTheWay3.webp`;

const Card1 = () => (
  <div className="border-policeblue-dark bg-white rounded-lg shadow-2xl sm:flex-row flex h-full flex-col items-center border-2">
    <div className="p-4 md:pr-0 sm:max-w-[40%] w-full">
      <Image
        alt="..."
        src={card1ImagePath}
        className="rounded-lg w-full"
        width={1920}
        height={1440}
      />
    </div>

    <div className="gap-4 p-4 md:p-6 lg:p-8 flex grow flex-col">
      <h3 className="text-policeblue-dark">
        Et si les meilleurs profils étaient{' '}
        <span className="md:inline-block block">ceux que l&apos;on n&apos;attend plus ?</span>
      </h3>

      <div className="text-charcoal">
        <p>
          Nous valorisons les talents de 45&nbsp;ans et plus là où ils ont le plus d&apos;impact :
        </p>

        <ul className="list-inside list-disc">
          <li>au cœur des projets complexes</li>
          <li>des métiers en tension</li>
          <li>des entreprises en mouvement</li>
        </ul>
      </div>
    </div>
  </div>
);

const Card2 = () => (
  <div className="border-policeblue-dark bg-white rounded-lg shadow-2xl sm:flex-row flex h-full flex-col items-center border-2">
    <div className="p-4 md:pr-0 sm:max-w-[40%] w-full">
      <Image
        alt="..."
        src={card2ImagePath}
        className="rounded-lg w-full"
        width={1920}
        height={1440}
      />
    </div>

    <div className="gap-4 p-4 md:p-6 lg:p-8 flex grow flex-col">
      <h3 className="text-policeblue-dark">
        L&apos;expérience n&apos;est pas un frein,{' '}
        <span className="md:inline-block block">c&apos;est une ressource.</span>
      </h3>

      <div className="text-charcoal text-lg md:text-xl">
        <p>Nous accompagnons les entreprises qui souhaitent recruter autrement avec :</p>

        <ul className="list-inside list-disc">
          <li>discernement</li>
          <li>ambition</li>
          <li>une vision durable de la performance</li>
        </ul>
      </div>
    </div>
  </div>
);

const Card3 = () => (
  <div className="border-policeblue-dark bg-white rounded-lg shadow-2xl sm:flex-row flex h-full flex-col items-center border-2">
    <div className="p-4 md:pr-0 sm:max-w-[40%] w-full">
      <Image
        alt="..."
        src={card3ImagePath}
        className="rounded-lg w-full"
        width={1920}
        height={1440}
      />
    </div>

    <div className="gap-4 p-4 md:p-6 lg:p-8 flex grow flex-col">
      <h3>
        Ils ont travaillé sans IA.
        <br />
        <span className="md:inline-block block"> Ils savent travailler avec.</span>
      </h3>

      <div className="text-charcoal space-y-4 text-lg md:text-xl">
        <p>
          Les talents de 45&nbsp;ans et plus d&apos;aujourd&apos;hui allient la mémoire des savoirs
          à la maîtrise des mutations.
        </p>

        <p>Un atout stratégique pour les entreprises de demain.</p>
      </div>
    </div>
  </div>
);

const SeniorsIsTheWay = () => {
  return (
    <section className="stonerwhitebg p-4 sm:p-8 md:p-10 lg:p-12 flex justify-center">
      <div className="gap-4 max-w-6xl m-auto flex w-full flex-col items-stretch justify-center">
        <div className="flex w-full flex-1">
          <Card1 />
        </div>

        <div className="flex w-full flex-1">
          <Card2 />
        </div>

        <div className="flex w-full flex-1">
          <Card3 />
        </div>
      </div>
    </section>
  );
};

export default SeniorsIsTheWay;
